import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { DashboardTitle } from "components/common";
//#endregion
import { DateHelper } from "utils/helpers";

const RevisorDashboardTitle: React.FC = () => {
  const annualReportFinancialYear = useSelector(
    (state: AppState) => state.auth.selectedCompany.annualAccountsFinancialYear
  );

  const financialYearText =
    annualReportFinancialYear?.end && annualReportFinancialYear?.start
      ? `${DateHelper.formatDateRange(annualReportFinancialYear?.start, annualReportFinancialYear?.end, "-")}`
      : undefined;

  return (
    <DashboardTitle
      title={TranslationKeys.Reports.RevisorView}
      subtitle={financialYearText}
      defaultTagSurface="background"
    />
  );
};

export default RevisorDashboardTitle;
